<script setup lang="ts">
import { HOME_ROUTE_NAME, MANUFACTURING_PROCESS_ROUTE_NAME } from '@/data/routes';
import type { MenuItem } from '@/types';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useTechMeasuresStore } from '@/store/techMeasures';
import { t } from '@/locales/i18n';

interface AppBarMenu {
  siteTree: MenuItem[];
  isLightTheme: boolean;
}

const routesWithoutAppBar = [HOME_ROUTE_NAME, MANUFACTURING_PROCESS_ROUTE_NAME];

const props = defineProps<AppBarMenu>();

const route = useRoute();

const techMeasureStore = useTechMeasuresStore();

const appClass = computed(() => ({
  'app-bar-menu': true,
  'app-bar-menu--light': props.isLightTheme
}));

const isAppBarMenuDisplayed = computed(
  () => routesWithoutAppBar.indexOf(route.name?.toString() ?? '') === -1
);

const getSectionItemClass = (item: MenuItem) => {
  return {
    'app-bar-menu__item': true,
    'app-bar-menu--light__item': props.isLightTheme,
    'app-bar-menu__item--active': route.path.startsWith(item.to || '')
  };
};

const getSectionTo = (item: MenuItem) => {
  const urlToRedirect =
    item.title === t('home.techMeasuresTab')
      ? `${item.to}/${techMeasureStore.manufacturingProcess}`
      : item.to;

  return urlToRedirect ?? '';
};
</script>

<template>
  <div v-if="isAppBarMenuDisplayed" :class="appClass">
    <router-link
      v-for="section in siteTree"
      :key="section.title"
      :bold="section.title"
      :class="getSectionItemClass(section)"
      :to="getSectionTo(section)"
    >
      {{ section.title }}
    </router-link>
  </div>
</template>

<style lang="scss" src="./AppBarMenu.scss" scoped />
